class MyleStaticResources {
    private _document_description: string[];

    constructor() {
        this._document_description = [];

        if (sessionStore.userLanguageCode == "fr" || sessionStore.userLanguageCode == "en") {
            this.InitDocDescription();
        }
    }

    private InitDocDescription(): void {
        this._document_description.push("Bilan de santé");
        this._document_description.push("Health Assessment");
        this._document_description.push("Consultation");
        this._document_description.push("Consulatation");
        this._document_description.push("Examen annuel");
        this._document_description.push("Annual Exam");
        this._document_description.push("Suivi");
        this._document_description.push("Follow-Up");
        this._document_description.push("Fit Test");
        this._document_description.push("Sans rendez-vous");
        this._document_description.push("Walk-In");
        this._document_description.push("Visite à domicile");
        this._document_description.push("House Visit");
        this._document_description.push("Consultation à l'hôpital");
        this._document_description.push("Hospital Consultation");
        this._document_description.push("Consultation téléphonique");
        this._document_description.push("Phone Consultation");
        this._document_description.push("Obstétrique");
        this._document_description.push("Obstetrics");
        this._document_description.push("Pédiatrie");
        this._document_description.push("Pediatrics");
        this._document_description.push("Gériatrie");
        this._document_description.push("Geriatrics");
        this._document_description.push("Allergie");
        this._document_description.push("Allergy");
        this._document_description.push("Anatomopathologie");
        this._document_description.push("Anatomopathology");
        this._document_description.push("Anesthésiologie");
        this._document_description.push("Anesthesiology");
        this._document_description.push("Biochimie médicale");
        this._document_description.push("Medical Biochemistry");
        this._document_description.push("Cardiologie");
        this._document_description.push("Cardiology");
        this._document_description.push("Chirurgie cardiaque");
        this._document_description.push("Cardiac Surgery");
        this._document_description.push("Chirurgie colorectale");
        this._document_description.push("Colorectal Surgery");
        this._document_description.push("Chirurgie générale oncologique");
        this._document_description.push("General Surgical Oncology");
        this._document_description.push("Chirurgie générale pédiatrique");
        this._document_description.push("General Surgical Pediatrics");
        this._document_description.push("Chirurgie générale");
        this._document_description.push("General Surgery");
        this._document_description.push("Chirurgie plastique");
        this._document_description.push("Plastic Surgery");
        this._document_description.push("Chirurgie thoracique");
        this._document_description.push("Thoracic Surgery");
        this._document_description.push("Chirurgie Vasculaire");
        this._document_description.push("Vascular Surgery");
        this._document_description.push("Dermatologie");
        this._document_description.push("Dermatology");
        this._document_description.push("Endocrinologie ");
        this._document_description.push("Endocrinology");
        this._document_description.push("Gastro-entérologie ");
        this._document_description.push("Gastroenterology");
        this._document_description.push("Génétique médicale");
        this._document_description.push("Medical Genetics");
        this._document_description.push("Hématologie - oncologie pédiatrique");
        this._document_description.push("Pediatric Hematology - Oncology");
        this._document_description.push("Hématologie - oncologie médicale");
        this._document_description.push("Medical Hematology - Oncology");
        this._document_description.push("Médecine de l'adolescence");
        this._document_description.push("Adolescent Medicine");
        this._document_description.push("Médecine du travail");
        this._document_description.push("Occupational Medicine");
        this._document_description.push("Médecine d'urgence");
        this._document_description.push("Emergency Medicine");
        this._document_description.push("Médecine d'urgence pédiatrique");
        this._document_description.push("Pediatric Emergency Medicine");
        this._document_description.push("Médecine interne ");
        this._document_description.push("Internal Medicine");
        this._document_description.push("Médecine maternelle et foetale");
        this._document_description.push("Maternal - Fetal Medicine");
        this._document_description.push("Médecine néonatale et périnatale");
        this._document_description.push("Neonatal and perinatal medicine");
        this._document_description.push("Médecine nucléaire");
        this._document_description.push("Nuclear Medicine");
        this._document_description.push("Microbiologie médicale et infectiologie");
        this._document_description.push("Medical Microbiology and Infectious Diseases");
        this._document_description.push("Néphrologie");
        this._document_description.push("Nephrology");
        this._document_description.push("Neurochirurgie");
        this._document_description.push("Neurosurgery");
        this._document_description.push("Neurologie ");
        this._document_description.push("Neurology");
        this._document_description.push("Neuropathologie");
        this._document_description.push("Neuropathology");
        this._document_description.push("Obstétrique et gynécologie");
        this._document_description.push("Obstetrics and Gynecology");
        this._document_description.push("Oncologie gynécologique");
        this._document_description.push("Gynecologic Oncology");
        this._document_description.push("Ophtalmologie");
        this._document_description.push("Ophthalmology");
        this._document_description.push("ORL");
        this._document_description.push("ENT");
        this._document_description.push("Orthopédie");
        this._document_description.push("Orthopedics");
        this._document_description.push("Pathologie générale");
        this._document_description.push("General Pathology");
        this._document_description.push("Pathologie judiciaire");
        this._document_description.push("Forensic Pathology");
        this._document_description.push("Pédopsychiatrie");
        this._document_description.push("Child and Adolescent Psychiatry");
        this._document_description.push("Physiatrie");
        this._document_description.push("Physiatry");
        this._document_description.push("Pneumologie");
        this._document_description.push("Pneumology");
        this._document_description.push("Psychiatrie");
        this._document_description.push("Psychiatry");
        this._document_description.push("Radiologie diagnostique");
        this._document_description.push("Diagnostic Radiology");
        this._document_description.push("Radio-oncologie");
        this._document_description.push("Radiation Oncology");
        this._document_description.push("Rhumatologie");
        this._document_description.push("Rheumatology");
        this._document_description.push("Santé communautaire");
        this._document_description.push("Community Health");
        this._document_description.push("Soins intensifs");
        this._document_description.push("Intensive Care");
        this._document_description.push("Urologie");
        this._document_description.push("Urology");
        this._document_description.push("Note de triage");
        this._document_description.push("Triage Note");
        this._document_description.push("Contraception");
        this._document_description.push("Contraception");
        this._document_description.push("Demande de services GMF");
        this._document_description.push("GMF Services Request");
        this._document_description.push("Désensibilisation");
        this._document_description.push("Desensitization");
        this._document_description.push("Note de soins");
        this._document_description.push("Healthcare Note");
        this._document_description.push("Note d'observation");
        this._document_description.push("Observation Note");
        this._document_description.push("Ordonnance collective");
        this._document_description.push("Collective Prescription");
        this._document_description.push("PTI");
        this._document_description.push("NCP");
        this._document_description.push("Services à domicile");
        this._document_description.push("Home Care Services");
        this._document_description.push("Suivi téléphoniques");
        this._document_description.push("Telephone Follow-Up");
        this._document_description.push("Vaccination");
        this._document_description.push("Vaccination");
        this._document_description.push("Clinique d'hypertension artérielle (HTA)");
        this._document_description.push("Hypertension Clinic (HTA)");
        this._document_description.push("Clinique de dyslipémie");
        this._document_description.push("Dyslipidemia Clinic");
        this._document_description.push("Clinique de la douleur");
        this._document_description.push("Pain Clinic");
        this._document_description.push("Clinique de la migraine");
        this._document_description.push("Migraine Clinic");
        this._document_description.push("Clinique de maladies cardio-respiratoires");
        this._document_description.push("Cardio-Respiratory Diseases Clinic");
        this._document_description.push("Clinique d'INR");
        this._document_description.push("INR Clinic");
        this._document_description.push("Clinique d'obésité - chirurgie bariatrique");
        this._document_description.push("Obesity - Bariatric Surgery Clinic");
        this._document_description.push("Clinique du diabète");
        this._document_description.push("Diabetes Clinic");
        this._document_description.push("Clinique du plancher pelvien");
        this._document_description.push("Pelvic Floor Clinic");
        this._document_description.push("Clinique du sein");
        this._document_description.push("Breast Clinic");
        this._document_description.push("Clinique du sommeil");
        this._document_description.push("Sleep Clinic");
        this._document_description.push("Test Pap");
        this._document_description.push("Pap Test");
        this._document_description.push("Dépistage de drogue");
        this._document_description.push("Drug Screening");
        this._document_description.push("Dépistage du cancer");
        this._document_description.push("Cancer Screening");
        this._document_description.push("Dysfonction thyroïdienne");
        this._document_description.push("Thyroid Dysfunction");
        this._document_description.push("Suivi d'anticoagulothérapie");
        this._document_description.push("Anticoagulation Monitoring");
        this._document_description.push("TDAH");
        this._document_description.push("ADHD");
        this._document_description.push("Psychologie");
        this._document_description.push("Psychology");
        this._document_description.push("Diététique");
        this._document_description.push("Dietetics");
        this._document_description.push("Physiologie");
        this._document_description.push("Physiology");
        this._document_description.push("Ergothérapie");
        this._document_description.push("Ergotherapy");
        this._document_description.push("Ostéopatie");
        this._document_description.push("Osteopathy");
        this._document_description.push("Évaluation de la condition physique");
        this._document_description.push("Evaluation of overall fitness");
        this._document_description.push("Optométrie");
        this._document_description.push("Optometry");
        this._document_description.push("Inhalothérapie");
        this._document_description.push("Inhalotherapy");
        this._document_description.push("Orthésie");
        this._document_description.push("Orthotics");
        this._document_description.push("Services sociaux");
        this._document_description.push("Social Services");
        this._document_description.push("Orthophonie");
        this._document_description.push("Speech Therapy");
        this._document_description.push("Pharmacie");
        this._document_description.push("Pharmacy");
        this._document_description.push("Évaluation psychiatrique");
        this._document_description.push("Psychiatric Evaluation");
        this._document_description.push("Évaluation du risque cardiovasculaire");
        this._document_description.push("Cardiovascular Risk Assessment");
        this._document_description.push("Biochimie");
        this._document_description.push("Biochemistry");
        this._document_description.push("Hématologie");
        this._document_description.push("Hematology");
        this._document_description.push("Microbiologie");
        this._document_description.push("Microbiology");
        this._document_description.push("Pathologie");
        this._document_description.push("Pathology");
        this._document_description.push("Cytologie");
        this._document_description.push("Cytology");
        this._document_description.push("Échographie");
        this._document_description.push("Ultrasound");
        this._document_description.push("Échographie abdominale");
        this._document_description.push("Abdominal Ultrasound");
        this._document_description.push("Échographie de la thyroïde");
        this._document_description.push("Thyroid Ultrasound");
        this._document_description.push("Échographie pelvienne");
        this._document_description.push("Pelvic Ultrasound");
        this._document_description.push("Électroneuromyographie");
        this._document_description.push("Electroneuromyography");
        this._document_description.push("IRM");
        this._document_description.push("MRI");
        this._document_description.push("Radiographie");
        this._document_description.push("Radiography");
        this._document_description.push("Échographie du sein");
        this._document_description.push("Breast Ultrasound");
        this._document_description.push("Mammographie");
        this._document_description.push("Mammography");
        this._document_description.push("Tomographie axiale (scan et CT scan)");
        this._document_description.push("Axial Tomography (Scan & CT Scan)");
        this._document_description.push("Echocardiogramme");
        this._document_description.push("Echocardiogram");
        this._document_description.push("Coronarographie");
        this._document_description.push("Coronarography");
        this._document_description.push("Bronchoscopie");
        this._document_description.push("Bronchoscopy");
        this._document_description.push("Colonoscopie");
        this._document_description.push("Colonoscopy");
        this._document_description.push("Colposcopie");
        this._document_description.push("Colposcopy");
        this._document_description.push("Cystoscopie");
        this._document_description.push("Cystoscopy");
        this._document_description.push("Endoscopie");
        this._document_description.push("Endoscopy");
        this._document_description.push("Gastroscopie");
        this._document_description.push("Gastroscopy");
        this._document_description.push("Laryngoscopie");
        this._document_description.push("Laryngoscopy");
        this._document_description.push("Proctoscopie");
        this._document_description.push("Proctoscopy");
        this._document_description.push("Rhinoscopie");
        this._document_description.push("Rhinoscopy");
        this._document_description.push("Doppler");
        this._document_description.push("Doppler");
        this._document_description.push("ECG à l'effort (tapis roulant)");
        this._document_description.push("Stress ECG (Treadmill)");
        this._document_description.push("ECG au repos");
        this._document_description.push("Resting ECG");
        this._document_description.push("Holter");
        this._document_description.push("Holter");
        this._document_description.push("Index tibio-huméral");
        this._document_description.push("Ankle-Brachial Index");
        this._document_description.push("INR");
        this._document_description.push("INR");
        this._document_description.push("MAPA");
        this._document_description.push("MAPA");
        this._document_description.push("Amniocentèse");
        this._document_description.push("Amniocentesis");
        this._document_description.push("Audio");
        this._document_description.push("Audio");
        this._document_description.push("Autres");
        this._document_description.push("Other");
        this._document_description.push("Test d'haleine pour H. Pylori");
        this._document_description.push("H. Pylory Breath Test");
        this._document_description.push("EEG");
        this._document_description.push("EEG");
        this._document_description.push("Électrophysiologie");
        this._document_description.push("Electrophysiology");
        this._document_description.push("EMG");
        this._document_description.push("EMG");
        this._document_description.push("ENG");
        this._document_description.push("ENG");
        this._document_description.push("Neurophysiologie");
        this._document_description.push("Neurophysiology");
        this._document_description.push("Ostéodensitométrie");
        this._document_description.push("Bone Densitometry");
        this._document_description.push("Provocation bronchitique");
        this._document_description.push("Bronchial Provocation");
        this._document_description.push("PSG");
        this._document_description.push("PSG");
        this._document_description.push("Pulmonaire");
        this._document_description.push("Pulmonary");
        this._document_description.push("Saturation O2");
        this._document_description.push("O2 Saturation");
        this._document_description.push("Spirométrie");
        this._document_description.push("Spirometry");
        this._document_description.push("Test d'allergie");
        this._document_description.push("Allergy Test");
        this._document_description.push("Test de la vue");
        this._document_description.push("Eye Test");
        this._document_description.push("Test infirmier");
        this._document_description.push("Nursing Test");
        this._document_description.push("Test d'urologie");
        this._document_description.push("Urology Test");
        this._document_description.push("TFR (Test Fonctionnel Respiratoire)");
        this._document_description.push("PFT (Pulmonary Function Test)");
        this._document_description.push("Accès à l'information");
        this._document_description.push("Access to Information");
        this._document_description.push("DSQ");
        this._document_description.push("DSQ");
        this._document_description.push("Inscription GMF");
        this._document_description.push("GMF Enrollment");
        this._document_description.push("Santé mentale");
        this._document_description.push("Mental Health");
        this._document_description.push("Retrait préventif");
        this._document_description.push("Preventive Withdrawal");
        this._document_description.push("SAAQ");
        this._document_description.push("SAAQ");
        this._document_description.push("CSST");
        this._document_description.push("CSST");
        this._document_description.push("CTMSP - Classification par types en milieu de soins et services prolongés");
        this._document_description.push("CTMSP - Classification by Types of Program in Extended Care and Service Facilities");
        this._document_description.push("MADO - Maladies a Déclaration Obligatoire");
        this._document_description.push("NDIS - Notifiable Diseases");
        this._document_description.push("PRISMA");
        this._document_description.push("PRISMA");
        this._document_description.push("Régie des Rentes du Québec");
        this._document_description.push("Régie des Rentes du Québec");
        this._document_description.push("Sécurité du revenu");
        this._document_description.push("Income Security");
        this._document_description.push("Congé de travail");
        this._document_description.push("Work Leave");
        this._document_description.push("Rapport médical");
        this._document_description.push("Medical Report");
        this._document_description.push("RAMQ");
        this._document_description.push("RAMQ");
        this._document_description.push("Assignation temporaire");
        this._document_description.push("Temporary Assignment");
        this._document_description.push("Assurance salaire");
        this._document_description.push("Income Insurance");
        this._document_description.push("Aptitude au travail");
        this._document_description.push("Ability to Work");
        this._document_description.push("Maladie à caractère professionnel");
        this._document_description.push("Occupational Disease");
        this._document_description.push("Attestation de déficience");
        this._document_description.push("Certificate of Disability");
        this._document_description.push("Attestation d'arrêt de travail");
        this._document_description.push("Certificate of Work Leave");
        this._document_description.push("Demande de vignette de stationnement");
        this._document_description.push("Parking Permit Application");
        this._document_description.push("Pré-emploi");
        this._document_description.push("Pre-Employment");
        this._document_description.push("Périodique");
        this._document_description.push("Periodic");
        this._document_description.push("Expertise");
        this._document_description.push("Expertise");
        this._document_description.push("Résumé du dossier");
        this._document_description.push("Patient Record Summary");
        this._document_description.push("Formulaire");
        this._document_description.push("Form");
        this._document_description.push("Résumé des antécédents");
        this._document_description.push("Medical History Summary");
        this._document_description.push("Formulaires d'invalidité");
        this._document_description.push("Disability Form");
        this._document_description.push("Comorbidité");
        this._document_description.push("Comorbidity");
        this._document_description.push("Pre-op");
        this._document_description.push("Pre-Op");
        this._document_description.push("Post-op");
        this._document_description.push("Post-Op");
        this._document_description.push("Ordonnance de non-réanimation");
        this._document_description.push("\"Do Not Resuscitate\" Order");
        this._document_description.push("Échelle de Framingham et risque cardio-métabolique");
        this._document_description.push("Framingham Scale and Cardiometabolic Risk");
        this._document_description.push("HTA");
        this._document_description.push("HTA");
        this._document_description.push("Lecteurs de glycémies et autres");
        this._document_description.push("Glucose Meters and Other Monitoring Devices");
        this._document_description.push("Tabagisme");
        this._document_description.push("Smoking");
        this._document_description.push("Troubles Cognitifs (MO Ca, Folstein)");
        this._document_description.push("Cognitive Disorders (MO Ca, Folstein)");
        this._document_description.push("Autorisation de transmission de données");
        this._document_description.push("Authorization for Data Exchange");
        this._document_description.push("Demande séquentielle");
        this._document_description.push("Sequential Application");
        this._document_description.push("Facturation immigration");
        this._document_description.push("Immigration Billing");
        this._document_description.push("Identification immigration");
        this._document_description.push("Immigration Identification");
        this._document_description.push("Frais facturés");
        this._document_description.push("Billed Fees");
        this._document_description.push("Certificat ou rapport médical");
        this._document_description.push("Medical Certificate or Report");
        this._document_description.push("Questionnaire");
        this._document_description.push("Questionnaire");
        this._document_description.push("Demandes de résumé de dossier");
        this._document_description.push("Patient Record Summary Request");
        this._document_description.push("Dossier papier numérisé");
        this._document_description.push("Scanned Paper Record");
        this._document_description.push("Permis de conduire");
        this._document_description.push("Driver's licence");
        this._document_description.push("Prescription");
        this._document_description.push("Renouvellement");
        this._document_description.push("Renewal");
        this._document_description.push("Autorisation de paiement");
        this._document_description.push("Payment authorization");
        this._document_description.push("Consultation à l'urgence");
        this._document_description.push("ER consult");
        this._document_description.push("Chirurgie");
        this._document_description.push("Surgery");
        this._document_description.push("Protocole opératoire");
        this._document_description.push("Surgical summary");
        this._document_description.push("Attestation d'inscription");
        this._document_description.push("Registration certificate");
        this._document_description.push("Échographie cardiaque");
        this._document_description.push("Echocardiogram");
        this._document_description.push("Échographie obstétricale");
        this._document_description.push("Obstetrical Ultrasound");
        this._document_description.push("Gynécologie");
        this._document_description.push("Gynecology");
        this._document_description.push("Audiology");
        this._document_description.push("Blood Bank");
        this._document_description.push("Cardiovascular Surgery");
        this._document_description.push("Cognition Clinic");
        this._document_description.push("Driver's Licence");
        this._document_description.push("DSIE");
        this._document_description.push("Emploi Québec");
        this._document_description.push("EKG");
        this._document_description.push("Geriatric depression scale");
        this._document_description.push("Hepatology");
        this._document_description.push("Immunization");
        this._document_description.push("Memory Clinic");
        this._document_description.push("Notice to Patient");
        this._document_description.push("NST");
        this._document_description.push("OBS Ultrasound");
        this._document_description.push("Observation");
        this._document_description.push("Oncology");
        this._document_description.push("Patient Correspondence");
        this._document_description.push("Pharmacist Communication");
        this._document_description.push("Physiotherapy");
        this._document_description.push("Release of Information");
        this._document_description.push("Stress Test");
        this._document_description.push("Surgery");
        this._document_description.push("Urogynecology");
        this._document_description.push("Vascular Clinic");
        this._document_description.push("VBAC");
        this._document_description.push("Women's Clinic");
        this._document_description.push("NT Scan");
        this._document_description.push("Fetal Ultrasound");
        this._document_description.push("External Correspondence");
        this._document_description.push("Obstetrical File");
        this._document_description.push("Pregnancy");
        this._document_description.push("Spinal Nerve Compression");
        this._document_description.push("Cervical Spine");
        this._document_description.push("Lumbar Spine");
        this._document_description.push("Bone CT Scan");
        this._document_description.push("Head CT Scan");
        this._document_description.push("Ambulatory EKG");
        this._document_description.push("Medical Day Unit");
        this._document_description.push("Pacemaker");
        this._document_description.push("Newborn Clinic");
        this._document_description.push("Audiologie");
        this._document_description.push("Banque de sang");
        this._document_description.push("Chirurgie cardiovasculaire");
        this._document_description.push("Clinique de cognition");
        this._document_description.push("Permis de conduire");
        this._document_description.push("DSIE");
        this._document_description.push("Emploi Québec");
        this._document_description.push("ECG");
        this._document_description.push("Échelle de dépression gériatrique");
        this._document_description.push("Hépatologie");
        this._document_description.push("Immunisation");
        this._document_description.push("Clinique de la mémoire");
        this._document_description.push("Notice au patient");
        this._document_description.push("Épreuve au repos");
        this._document_description.push("Échographie obstétricale");
        this._document_description.push("Observation");
        this._document_description.push("Oncologie");
        this._document_description.push("Correspondance au patient");
        this._document_description.push("Communication au pharmacien");
        this._document_description.push("Physiothérapie");
        this._document_description.push("Divulgation d'information");
        this._document_description.push("Épreuve à l'effort");
        this._document_description.push("Chirurgie");
        this._document_description.push("Uro-gynécologie");
        this._document_description.push("Clinique vasculaire");
        this._document_description.push("AVAC");
        this._document_description.push("Clinique des femmes");
        this._document_description.push("Clarté nucale");
        this._document_description.push("Échographie foetale");
        this._document_description.push("Correspondance externe");
        this._document_description.push("Dossier obstétrical");
        this._document_description.push("Grossesse");
        this._document_description.push("Bloc foraminal");
        this._document_description.push("Colonne cervicale");
        this._document_description.push("Colonne lombaire");
        this._document_description.push("Scannographie osseuse");
        this._document_description.push("Scannographie cardiaque");
        this._document_description.push("ECG ambulatoire");
        this._document_description.push("Unité de médecine de jour");
        this._document_description.push("Cardiostimulateur");
        this._document_description.push("Périnatalité");
        this._document_description.push("Kinésiothérapie");
        this._document_description.push("Demande d'admission ");
        this._document_description.push("Poumons");
        this._document_description.push("Attestation médicale");
        this._document_description.push("Rapport final");
        this._document_description.push("Mini-Chirurgie");
        this._document_description.push("Immunohistochemistry report");
        this._document_description.push("Biopsie guidée par échographie");
        this._document_description.push("Échocardiographie transthoracique");
        this._document_description.push("Protocole opératoire");
        this._document_description.push("Operation report");
        this._document_description.push("Core biopsy by ultrasound");
        this._document_description.push("Rapport d'opération");
        this._document_description.push("Surgical pathology report");
        this._document_description.push("Cytopathologie");
        this._document_description.push("Lavement baryté double contraste");
        this._document_description.push("Compte rendu opératoire");
        this._document_description.push("Cytopathology");
        this._document_description.push("Ariane");
        this._document_description.push("Questionnaire pt SRV");
        this._document_description.push("Feuille triage CHUS");
        this._document_description.push("Dépistage prénatal");
        this._document_description.push("Écho 20 semaine");
        this._document_description.push("écho 32 semaine");
        this._document_description.push("Bilan Sanguin");
        this._document_description.push("Routine de Grossesse");
        this._document_description.push("Hospitalisation");
        this._document_description.push("Pacemaker - Suivi");
        this._document_description.push("Électromyogramme");
        this._document_description.push("Demande de résumé de dossier");
        this._document_description.push("Rapport médical - Permis de conduire");
        this._document_description.push("Test Fit ");

        this._document_description = this._document_description.sort((x, y) => {
            if (x > y) return 1;
            if (x < y) return -1;
            return 0;
        });
    }

    public GetDocumentDescription(): string[] { return this._document_description; }
}

export { MyleStaticResources };
